
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/category/[taxonomy]",
      function () {
        return require("private-next-pages/blog/category/[taxonomy].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/category/[taxonomy]"])
      });
    }
  